module.exports = __webpack_public_path__ + "static/media/confeitaria-duque-caxias-logo-branding-768x591.ed909f75.jpg";